import React from 'react';
import FlowModalComponent from "./flow-modal-component";
import {FlowStepRow} from "./flow-step-row";
import {Constants} from "../../../../constants";
import TopActionsComponent from "../../../top-actions-component";
import Header from "../../../header";
import RedirectIfNotLogged from "../../../menu/redirect-if-not-logged";
import request from "../../../../config/axios-config";
import {CircularProgress} from "material-ui";

class FlowPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            steps: [],
            showAdd: false,
            showEdit: false,
            forceLogin: false,
            loadingData: false,
            emptyData: false,
        };
    }

    componentDidMount() {
        this.refreshData();
    };

    refreshData = () => {
        this.setState({loadingData: true});
        request({
            url: Constants.SERVER_ENDPOINT + '/flow/all',
            method: "GET",
        }).then(json => {
            let isEmptyData = !json.data || json.data.length === 0;
            this.setState({
                flowId: json.data.flow ? json.data.flow.id : null,
                steps: json.data.flow ? json.data.flow.steps : null,
                users: json.data.users,
                loadingData: false,
                emptyData: isEmptyData
            });
        }).catch(err => {
            this.setState({loadingData: false});
        })
    };

    onAddClicked = () => {
        this.setState({
            showAdd: true
        });
        this.props.onDialogVisible(true);
    };

    onEditClicked = (id, flowStepId, email, order, canEditPapers, calling, canSetArticolBugetar) => {
        this.setState({
            showEdit: true,
            selectedEditOrder: order,
            selectedUserId: id,
            flowStepId: flowStepId,
            canEditPapers: canEditPapers,
            canSetArticolBugetar: canSetArticolBugetar,
            calling: calling
        });
        this.props.onDialogVisible(true);
    };

    onCancel = () => {
        this.setState({
            showEdit: false,
            showAdd: false
        });
        this.refreshData();
        this.props.onDialogVisible(false);
    };


    onDeleteClicked = (id) => {
        request({
                url: Constants.SERVER_ENDPOINT + '/flow/delete/step/' + id,
                method: "POST",
            }
        ).then(json => {
            this.refreshData();
        }).catch(err => {
            this.setState({
                loadingData: false
            });
        })
    };

    render() {
        let steps = this.state.steps || [];
        let rows = steps.map((el, i) => {
            return (
                <FlowStepRow
                    key={el.signedBy.id}
                    index={i}
                    signedById={el.signedBy.id}
                    flowStepId={el.id}
                    canEditPapers={el.canEditPapers}
                    canSetArticolBugetar={el.canSetArticolBugetar}
                    calling={el.calling}
                    email={el.signedBy.email}
                    orderNumber={el.stepOrder}
                    onEditClicked={this.onEditClicked}
                    onDeleteClicked={this.onDeleteClicked}
                />
            )
        });
        return (
            <div>
                <RedirectIfNotLogged/>

                <Header title={"Setari persoane cu drept de aprobare referate"}/>

                {this.state.showAdd === true
                    /*Show ADD MODAL*/
                    ? <FlowModalComponent
                        flowId={this.state.flowId}
                        users={this.state.users}
                        onCancel={this.onCancel}
                    /> : ""
                }

                {this.state.showEdit === true
                    /*Show EDIT MODAL*/
                    ? <FlowModalComponent
                        flowId={this.state.flowId}
                        flowStepId={this.state.flowStepId}
                        users={this.state.users}
                        canEditPapers={this.state.canEditPapers}
                        canSetArticolBugetar={this.state.canSetArticolBugetar}
                        selectedUserId={this.state.selectedUserId}
                        orderNumber={this.state.selectedEditOrder}
                        calling={this.state.calling}
                        onCancel={this.onCancel}
                    /> : ""
                }

                {
                    this.state.loadingData
                        ? <div style={{textAlign: 'center'}}>
                            <CircularProgress/>
                        </div>
                        : this.state.emptyData
                        ? <div>
                            <div style={{float: 'right'}}>
                                <TopActionsComponent onAddClicked={this.onAddClicked}/>
                            </div>
                            <div style={{textAlign: 'center', marginTop: '50px'}}>
                                <h3>Nu exista date!</h3>
                            </div>
                        </div>
                        : <div>
                            <div style={{width: '75%', margin: "0 auto"}}>
                                <div style={{float: 'right'}}>
                                    <TopActionsComponent onAddClicked={this.onAddClicked}/>
                                </div>
                                <div>
                                    <table className='table table-hover table-responsive'>
                                        <tbody>
                                        <tr>
                                            <th>Numar ordine</th>
                                            <th>Email utilizator</th>
                                            <th>Poate edita referate?</th>
                                            <th>Poate seta articol bugetar?</th>
                                            <th>Titlu</th>
                                            <th>Edit / Delete</th>
                                        </tr>
                                        {rows}
                                        </tbody>
                                    </table>

                                    <p>*No modificati aceasta pagina fara sa stiti exact ce faceti!</p>
                                    <p style={{marginTop: '10px'}}> *Fiecare email trebuie sa fie unic. Nu pot exista duplicate</p>
                                </div>
                            </div>
                        </div>
                }
            </div>
        )
    }

}

export default FlowPage;